<template>
    <div style="padding: 20px; height: 100vh; overflow-y: auto; box-sizing: border-box;">
        <el-descriptions :title="paymentInfo.inventoryCustomerName" :column="4" border class="desc-even">
            <template slot="extra" v-if="!paymentId">
                <el-date-picker v-model="month" type="month" format="yyyyMM" value-format="yyyyMM" placeholder="不限账单月份" @change="getData"></el-date-picker>
            </template>
            <!-- 客户基本信息 -->
            <el-descriptions-item label="数据项" span="7">客户基本信息</el-descriptions-item>
            <el-descriptions-item label="月份">{{ paymentInfo.inventoryCommonMonth }}</el-descriptions-item>
            <el-descriptions-item label="负责人">{{ paymentInfo.inventoryCustomerPerson }}</el-descriptions-item>
            <el-descriptions-item label="项目">{{ paymentInfo.inventoryCategoryName }}</el-descriptions-item>
            <el-descriptions-item label="税号">{{ paymentInfo.inventoryCustomerTax }}</el-descriptions-item>
            <!-- 上游计划费用 -->
            <el-descriptions-item label="数据项" span="7">上游计划费用</el-descriptions-item>
            <el-descriptions-item label="计划贸易量">{{ paymentInfo.inventoryAccountPlanTradeAmount }}</el-descriptions-item>
            <el-descriptions-item label="上游费率">{{ paymentInfo.inventoryCategoryPercentUp }}</el-descriptions-item>
            <el-descriptions-item label="上游计划费用">{{ paymentInfo.inventoryAccountPlanTradeFee }}</el-descriptions-item>
            <el-descriptions-item label="上游计划过夜比例">{{ paymentInfo.inventoryAccountPlanNightPercent
                }}</el-descriptions-item>
            <el-descriptions-item label="上游计划过夜费率">{{ paymentInfo.inventoryAccountPlanNightRate
                }}</el-descriptions-item>
            <el-descriptions-item label="上游计划过夜费">{{ paymentInfo.inventoryAccountPlanNightFee }}</el-descriptions-item>
            <el-descriptions-item label="计划利差比例">{{ paymentInfo.inventoryAccountPlanProfitRate }}</el-descriptions-item>
            <el-descriptions-item label="上游计划利差金额">{{ paymentInfo.inventoryAccountPlanProfitFee
                }}</el-descriptions-item>
            <el-descriptions-item label="上游计划备注">{{ paymentInfo.inventoryAccountPlanMemo }}</el-descriptions-item>
            <el-descriptions-item label="上游计划服务费">{{ paymentInfo.inventoryAccountPlanServiceTotal
                }}</el-descriptions-item>
            <el-descriptions-item label="上游计划合计">{{ paymentInfo.inventoryAccountPlanFeeTotal }}</el-descriptions-item>
            <el-descriptions-item label=""></el-descriptions-item>
            <!-- 上游实际费用 -->
            <el-descriptions-item label="数据项" span="7">上游实际费用</el-descriptions-item>
            <el-descriptions-item label="实际开票金额">{{ paymentInfo.inventoryAccountActualTradeAmount
                }}</el-descriptions-item>
            <el-descriptions-item label="上游费率">{{ paymentInfo.inventoryCategoryPercentUp }}</el-descriptions-item>
            <el-descriptions-item label="上游实际贸易服务费">{{ paymentInfo.inventoryAccountActualServiceFee
                }}</el-descriptions-item>
            <el-descriptions-item label="上游实际利差费率">{{ paymentInfo.inventoryAccountPlanProfitRate
                }}</el-descriptions-item>
            <el-descriptions-item label="上游实际利差">{{ paymentInfo.inventoryAccountActualProfit }}</el-descriptions-item>
            <el-descriptions-item label="上游实际过夜金额">{{ paymentInfo.inventoryAccountActualNightAmount
                }}</el-descriptions-item>
            <el-descriptions-item label="上游实际过夜费率">{{ paymentInfo.inventoryAccountPlanNightRate
                }}</el-descriptions-item>
            <el-descriptions-item label="上游实际过夜费">{{ paymentInfo.inventoryAccountActualNightFee
                }}</el-descriptions-item>
            <el-descriptions-item label="上游实际备注">{{ paymentInfo.inventoryAccountActualMemo }}</el-descriptions-item>
            <el-descriptions-item label="上游实际合计">{{ paymentInfo.inventoryAccountActualTotal }}</el-descriptions-item>
            <el-descriptions-item label="上游实际预付">{{ paymentInfo.inventoryAccountActualPay }}</el-descriptions-item>
            <el-descriptions-item label="上游实际剩余">{{ paymentInfo.inventoryAccountActualUnpay }}</el-descriptions-item>
            <!-- 下游计划费用 -->
            <el-descriptions-item label="数据项" span="7">下游计划费用</el-descriptions-item>
            <el-descriptions-item label="计划贸易量">{{ paymentInfo.inventoryAccountPlanTradeAmount }}</el-descriptions-item>
            <el-descriptions-item label="下游费率">{{ paymentInfo.inventoryCategoryPercentDown }}</el-descriptions-item>
            <el-descriptions-item label="下游计划贸易费用">{{ paymentInfo.inventoryPaymentPlanTradeFee }}</el-descriptions-item>
            <el-descriptions-item label="下游计划过夜比例">{{ paymentInfo.inventoryAccountPlanNightPercent
                }}</el-descriptions-item>
            <el-descriptions-item label="下游计划过夜费率">{{ paymentInfo.inventoryPaymentPlanNightRate
                }}</el-descriptions-item>
            <el-descriptions-item label="下游计划过夜费">{{ paymentInfo.inventoryPaymentPlanNightFee }}</el-descriptions-item>
            <el-descriptions-item label="计划利差比例">{{ paymentInfo.inventoryAccountPlanProfitRate }}</el-descriptions-item>
            <el-descriptions-item label="下游计划利差">{{ paymentInfo.inventoryPaymentPlanProfitFee }}</el-descriptions-item>
            <el-descriptions-item label="下游财务费">{{ paymentInfo.inventoryPaymentPlanFeeFinance }}</el-descriptions-item>
            <el-descriptions-item label="下游计划服务费">{{ paymentInfo.inventoryPaymentPlanFeeService
                }}</el-descriptions-item>
            <el-descriptions-item label="下游计划总计">{{ paymentInfo.inventoryPaymentPlanFeeTotal }}</el-descriptions-item>
            <el-descriptions-item label=""></el-descriptions-item>
            <!-- 下游实际费用 -->
            <el-descriptions-item label="数据项" span="7">下游实际费用</el-descriptions-item>
            <el-descriptions-item label="实际开票金额">{{ paymentInfo.inventoryAccountActualTradeAmount
                }}</el-descriptions-item>
            <el-descriptions-item label="下游实际服务费">{{ paymentInfo.inventoryPaymentActualTradeService
                }}</el-descriptions-item>
            <el-descriptions-item label="下游实际利差费率">{{ paymentInfo.inventoryAccountPlanProfitRate
                }}</el-descriptions-item>
            <el-descriptions-item label="下游实际利差">{{ paymentInfo.inventoryPaymentActualProfitFee
                }}</el-descriptions-item>
            <el-descriptions-item label="下游实际过夜金额">{{ paymentInfo.inventoryPaymentActualNightAmount
                }}</el-descriptions-item>
            <el-descriptions-item label="下游实际过夜费">{{ paymentInfo.inventoryPaymentActualNightFee
                }}</el-descriptions-item>
            <el-descriptions-item label="服务费">{{ paymentInfo.inventoryPaymentActualServiceTotal }}</el-descriptions-item>
            <el-descriptions-item label="下游财务费">{{ paymentInfo.inventoryPaymentPlanFeeFinance }}</el-descriptions-item>
            <el-descriptions-item label="下游实际总费用">{{ paymentInfo.inventoryPaymentActualFeeTotal
                }}</el-descriptions-item>
            <el-descriptions-item label="下游实际预付">{{ paymentInfo.inventoryPaymentActualPay }}</el-descriptions-item>
            <el-descriptions-item label="下游实际剩余">{{ paymentInfo.inventoryPaymentActualUnpay }}</el-descriptions-item>
            <el-descriptions-item label=""></el-descriptions-item>
            <el-descriptions-item label="" span="3"></el-descriptions-item>
            <!-- 费用统计汇总 -->
            <el-descriptions-item label="数据项" span="7">费用统计汇总</el-descriptions-item>
            <el-descriptions-item label="上游计划合计">{{ paymentInfo.inventoryAccountPlanFeeTotal }}</el-descriptions-item>
            <el-descriptions-item label="下游计划合计">{{ paymentInfo.inventoryPaymentPlanFeeTotal }}</el-descriptions-item>
            <el-descriptions-item label="计划利润">{{ paymentInfo.inventoryCommonPlanProfit }}</el-descriptions-item>
            <el-descriptions-item label="上游实际合计">{{ paymentInfo.inventoryAccountActualTotal }}</el-descriptions-item>
            <el-descriptions-item label="下游实际合计">{{ paymentInfo.inventoryPaymentActualFeeTotal }}</el-descriptions-item>
            <el-descriptions-item label="实际利润">{{ paymentInfo.inventoryCommonActualProfit }}</el-descriptions-item>
            <el-descriptions-item label="上游结算"><el-tag size="small"
                    :type="paymentInfo.inventoryAccountActualStatus == 1 ? 'success' : 'error'">{{
            paymentInfo.inventoryAccountActualStatus == 1 ? "已结账" : "未结账" }}</el-tag></el-descriptions-item>
            <el-descriptions-item label="下游结算"><el-tag size="small"
                    :type="paymentInfo.inventoryPaymentActualStatus == 1 ? 'success' : 'error'">{{
            paymentInfo.inventoryPaymentActualStatus == 1 ? "已结账" : "未结账" }}</el-tag></el-descriptions-item>
        </el-descriptions>
        <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 15px;">
            <el-pagination background layout="prev, pager, next" :total="paymentList.length" page-size="1" @current-change="currentChange"></el-pagination>
            <el-button type="primary" size="middle" @click="layerClose">关闭</el-button>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import { API, doPost } from "@/api/api.js"

export default {
    mixins: [verifyMixin, imageMixin],
    props: ["paymentId", "customerId", "categoryId"],
    data: function () {
        return {
            current: 1,
            month: "",
            paymentList: []
        }
    },
    computed: {
        paymentInfo: function () {
            if (this.paymentList.length > 0) {
                return this.paymentList[this.current - 1];
            }
            return {};
        }
    },
    methods: {
        layerClose: function () {
            this.$emit("close");
        },
        currentChange: function (current) {
            this.current = current;
        },
        getData: async function () {
            this.paymentList = await doPost(API.PAYMENT_DETAIL, {
                paymentId: this.paymentId,
                customerId: this.customerId,
                categoryId: this.categoryId,
                month: this.month
            });
            if (this.paymentList == null || this.paymentList.length == 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'warning'
                });
            }
        }
    },
    created: function () {
        this.getData();
    },
}
</script>
<style scoped lang="less">
.desc-even {
    --desc-label-w: 80px; // 按需调整

    :deep(.el-descriptions__body) {
        table {
            table-layout: fixed;
            width: 100%;
        }

        .el-descriptions__label.is-bordered-label {
            width: var(--desc-label-w);
        }

        // content 不设宽 → 剩余空间被 3 列平分，每项严格等宽
        .el-descriptions__content.is-bordered-content {
            word-break: break-all; // 长地址换行，别撑破布局
        }
    }
}
</style>